import AlignTextBlock from './align-text-block';

export default AlignTextBlock;
